// fslint-disable unitTests
import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export const initialiseSentry = (app: App, router: Router): void => {
  if (import.meta.env.VITE_SENTRY_LOGGING === 'TRUE') {
    Sentry.init({
      app,
      environment: import.meta.env.VITE_ENVIRONMENT,
      dsn: 'https://cf5e3e6e7ff2d9a5684b5a8df8c78ec8@o4507905269432320.ingest.de.sentry.io/4508041211543632',
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost'],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
};
